const AUTO_VISIBILETO_PARAM = "__auto__";

function countChars(value) {
	let txt = document.forms.smsForm.text.value;
	let velikost = txt.length;
	document.forms.smsForm.size.value = velikost;
	if (velikost > 160) // SMS limit
	{
		document.forms.smsForm.size.style.backgroundColor = "#FF9999";
	}
	else {
		document.forms.smsForm.size.style.backgroundColor = "#CCFFCC";
	}
}
window.countChars = countChars;

export function countGenericChars(titleElement, thisElement) 
{	
	let velikost = $(thisElement).val().length;
	$(titleElement).val(velikost);
	if (velikost > 160) // SMS limit
	{
		$(titleElement).css("backgroundColor","#FF9999");
	}
	else {
		$(titleElement).css("backgroundColor","#CCFFCC");
	}
}

export function switchVisibility(value)
{
	let visibleToLink = document.getElementById("visibleToLink");
	let visibleTo = document.getElementById("visibleTo");

	if(value != false)
	{
		visibleTo.disabled = true;
		visibleToLink.href = "javascript:nothing()";
		document.getElementById('visibleToTitleRow').style.display = 'none';
		visibleTo.value= AUTO_VISIBILETO_PARAM;
	}
	else
	{
		visibleTo.disabled = false;
		let titleRow = document.getElementById('visibleToTitleRow');
		if (titleRow != null && titleRow.style.display !== 'none') {
			visibleTo.selectedIndex = visibleTo.length - 1;
		} else {
			if (visibleTo.value === AUTO_VISIBILETO_PARAM) visibleTo.selectedIndex = 0;
		}
		visibleToLink.href = "javascript:show_user_picker_detailed(document.smsForm.visibleTo.value,'document.smsForm','visibleToTitle','visibleTo');";
	}
}

window.nothing = function() {};

function setRefresh(value)
{
	let refVis = document.getElementById('refreshVisibility');
	let elm = document.getElementById(value);
	if(elm.value == 'true') refVis.checked = true;
	else refVis.checked = false;
}
